import { render, staticRenderFns } from "./LeftArrowIcon.vue?vue&type=template&id=23d621d4&"
import script from "./LeftArrowIcon.vue?vue&type=script&lang=ts&"
export * from "./LeftArrowIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports